export const SET_SELECTED_CELL = 'SET_SELECTED_CELL';
export const SET_SELECTED_MENU = 'SET_SELECTED_MENU';
export const SET_VISIBLE_MENUS = 'SET_VISIBLE_MENUS';
export const SET_COLOR_MODE = 'SET_COLOR_MODE';
export const SET_GENERATIONS_LOCKED = 'SET_GENERATIONS_LOCKED';


// WEBPACK FOOTER //
// ./src/core/ui/action-types.js